import { render, staticRenderFns } from "./scorecard-order-clubspecific-step2.vue?vue&type=template&id=47a58088&scoped=true"
import script from "./scorecard-order-clubspecific-step2.vue?vue&type=script&lang=js"
export * from "./scorecard-order-clubspecific-step2.vue?vue&type=script&lang=js"
import style0 from "./scorecard-order-clubspecific-step2.vue?vue&type=style&index=0&id=47a58088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a58088",
  null
  
)

export default component.exports